// ─── JEMS3 page view modes ─────────────────────────────────────────────────
// Toda página do JEMS3 pode ser aberta em um destes três modos. O modo afeta
// a quantidade de "chrome" do aplicativo (barra de navegação, breadcrumbs,
// menus, etc.) renderizada ao redor do conteúdo da página.
//
//   • NORMAL — chrome completo: navbar/sidenav/breadcrumb sempre visíveis.
//              Modo padrão para uso interativo na aplicação web.
//
//   • AMPLO  — apenas a barra de navegação superior, que adicionalmente se
//              esconde automaticamente quando o usuário rola pra baixo
//              (aparece de novo ao rolar pra cima ou ao chegar perto do topo).
//              Maximiza área útil sem abrir mão de navegação acessível.
//
//   • FULL   — sem nenhum chrome do app: só o conteúdo da página, edge-to-edge.
//              Para apresentação/projeção, screenshots, embed em iframe externo.
//
// A escolha do modo é por página/rota (não global): cada tela decide qual
// faz sentido pra sua proposta. Mecanismo de seleção (query param? rota
// dedicada? input do componente?) a definir em instrução subsequente.
// ───────────────────────────────────────────────────────────────────────────

export enum PageViewMode {
  Normal = 'normal',
  Amplo = 'amplo',
  Full = 'full',
}

export const DEFAULT_PAGE_VIEW_MODE: PageViewMode = PageViewMode.Normal;
